import { render, staticRenderFns } from "./DeliveredOrderToolbar.vue?vue&type=template&id=55c76ce0"
import script from "./DeliveredOrderToolbar.vue?vue&type=script&lang=js"
export * from "./DeliveredOrderToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports